import React from 'react';
import { TableCell } from '@mui/material';
import SortingColumn from '#component/table/sorting-column';

export const FirstAndLastNameCell = ({ order, orderBy, handleRequestSort }) => (
  <SortingColumn
    width="auto"
    id="firstName"
    title="User"
    order={order}
    orderBy={orderBy}
    onRequestSort={handleRequestSort}
  />
);

export const DevicesCell = () => <TableCell align="left">Devices</TableCell>;

export const RootProjectCell = () => <TableCell align="left">Root project</TableCell>;

export const EmailCell = () => <TableCell align="left">Email</TableCell>;

export const LogsCell = () => (
  <TableCell width={50} />
);

export const EditCell = () => (
  <TableCell width={50} />
);
